<div class="flex items-end h-150 w-full text-white bg-cover bg-no-repeat relative">
  <app-photo class="absolute top-0 left-0 right-0 w-full h-full" [photo]="photo"></app-photo>
  <div class="absolute bottom-0 left-0 right-0 from-imageGradient to-imageGradient-1 bg-gradient-to-t h-75"></div>
  <div class="flex flex-wrap md:flex-nowrap container px-6 mx-auto max-w-screen-xl relative">
    <div class="w-full mb-4 md:mb-0 md:w-auto md:mr-4"> <!-- Titles -->
      <h1 class="text-3xl pt-4 m-0">
        <app-copy-to-clipboard data-test="copy-clipboard-title" [value]="commercialProjectName || title">{{ commercialProjectName || title }}</app-copy-to-clipboard>
        @if (commercialProjectName) {
          <vwui-tooltip [label]="'Dit project staat ook bekend als: ' + title"
            position="right">
            <vwui-icon iconName="icon-info" class="ml-2 cursor-pointer vwui-icon-stroke vwui-icon-sm"></vwui-icon>
          </vwui-tooltip>
        }
      </h1>
      <h3>
        <app-copy-to-clipboard [value]="subtitle">{{ subtitle }}</app-copy-to-clipboard>
      </h3>
    </div>
    <div class="w-full md:w-91 ml-auto h-32 px-8 py-10 bg-primary rounded-t-lg font-medium shrink-0 self-end">
      <span class="text-sm opacity-60">Onderneming</span>
      <h2 class="text-lg m-0">
        <app-copy-to-clipboard [value]="company">{{ company }}</app-copy-to-clipboard>
      </h2>
    </div>
  </div>
</div>
